import { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import Select from "react-select";

const AddNewRpaUser = ({
  setOpen,
  selectedUser,
  hospitalTmsCredentials,
  setHospitalTmsCredentials,
  selectedHospitalTmsUser,
  setSelectedHospitalTmsUser,
  type,
  applicationIds,
}) => {
  const [newUser, setNewUser] = useState(
    selectedHospitalTmsUser ? selectedHospitalTmsUser?.pmjayNumber : "",
  );
  const [alternateNumber, setAlternateNumber] = useState(
    selectedHospitalTmsUser ? selectedHospitalTmsUser?.alternateNumber : "",
  );
  const [credentialFor, setCredentialFor] = useState(
    selectedHospitalTmsUser ? selectedHospitalTmsUser?.credentialFor : null,
  );
  const [reqType, setReqType] = useState(
    selectedHospitalTmsUser ? selectedHospitalTmsUser?.reqType : null,
  );
  const [applicationId, setApplicationId] = useState(
    selectedHospitalTmsUser ? selectedHospitalTmsUser?.applicationId : null,
  );
  const handleSave = () => {
    if (type === "add") {
      if (newUser.length === 10 && credentialFor) {
        setHospitalTmsCredentials([
          ...hospitalTmsCredentials,
          {
            hospitalId: selectedUser?.hospital?.id,
            pmjayUserId: selectedUser?.hospital?.pmjayUserId,
            pmjayNumber: newUser,
            credentialFor: credentialFor,
            alternateNumber: alternateNumber,
            reqType: reqType,
            applicationId: applicationId,
          },
        ]);
        setNewUser("");
        setSelectedHospitalTmsUser(null);
        setOpen(false);
      } else {
        window.alert(
          "Phone Number must be of 10 digits and credential fot must be selected",
        );
      }
    } else {
      const modifiedData = hospitalTmsCredentials?.map((cred) => {
        if (cred.id === selectedHospitalTmsUser.id) {
          return {
            ...cred,
            pmjayNumber: newUser,
            credentialFor: credentialFor,
            alternateNumber: alternateNumber,
            reqType: reqType,
            applicationId: applicationId,
          };
        } else {
          return cred;
        }
      });
      setHospitalTmsCredentials(modifiedData);
      setNewUser();
      setSelectedHospitalTmsUser(null);
      setOpen(false);
    }
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-[#017c5780] flex justify-center items-center z-[1201]">
      <div className="relative bg-white rounded-[16px] p-10 h-fit w-[20%] p-5">
        <Close
          className="absolute top-3 right-4 font-semibold text-2xl hover:text-gray-700 cursor-pointer"
          alt="close-icon"
          onClick={() => {
            setOpen(false);
            setSelectedHospitalTmsUser(null);
          }}
        />
        <div className="flex flex-col items-center gap-4  mt-7">
          <input
            type="text"
            value={newUser}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,10}$/.test(value)) {
                setNewUser(value);
              }
            }}
            style={{
              border: "1px solid #E4E4E4",
            }}
            className="w-[90%] h-[40px] outline-none rounded-[8px] px-3 py-[8px]"
            maxLength={10}
            placeholder="Enter Mobile Number"
          />
          <input
            type="text"
            value={alternateNumber}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,10}$/.test(value)) {
                setAlternateNumber(value);
              }
            }}
            style={{
              border: "1px solid #E4E4E4",
            }}
            className="w-[90%] h-[40px] outline-none rounded-[8px] px-3 py-[8px]"
            maxLength={10}
            placeholder="Enter Alternate Mobile Number"
          />
          <div className="w-[90%]">
            <Select
              options={[
                { value: "RPA", label: "RPA" },
                { value: "CC", label: "CC" },
              ]}
              value={[
                { value: "RPA", label: "RPA" },
                { value: "CC", label: "CC" },
              ]?.filter((item) => item.value === credentialFor)}
              getOptionLabel={(options) => options["label"]}
              getOptionValue={(options) => options["value"]}
              onChange={(item) => setCredentialFor(item.value)}
            />
          </div>
          {/* "ALL","NEW_CASE",'STATUS_UPDATE', 'UPLOAD_DOCUMENT', */}
          <div className="w-[90%]">
            <Select
              options={[
                { value: "ALL", label: "ALL" },
                { value: "NEW_CASE", label: "NEW_CASE" },
                { value: "STATUS_UPDATE", label: "STATUS_UPDATE" },
                { value: "UPLOAD_DOCUMENT", label: "UPLOAD_DOCUMENT" },
              ]}
              value={[
                { value: "ALL", label: "ALL" },
                { value: "NEW_CASE", label: "NEW_CASE" },
                { value: "STATUS_UPDATE", label: "STATUS_UPDATE" },
                { value: "UPLOAD_DOCUMENT", label: "UPLOAD_DOCUMENT" },
              ]?.filter((item) => item.value === reqType)}
              getOptionLabel={(options) => options["label"]}
              getOptionValue={(options) => options["value"]}
              onChange={(item) => setReqType(item.value)}
              placeholder="Request Type"
            />
          </div>
          <div className="w-[90%]">
            <Select
              options={applicationIds?.map((application) => ({
                value: application.applicationId,
                label: `${application.applicationId}-${application.ownerName}`,
              }))}
              value={applicationIds
                ?.map((application) => ({
                  value: application.applicationId,
                  label: `${application.applicationId}-${application.ownerName}`,
                }))
                ?.find((item) => String(item.value) === String(applicationId))}
              getOptionLabel={(options) => options.label}
              getOptionValue={(options) => String(options.value)}
              onChange={(item) => setApplicationId(item?.value || null)}
              placeholder="Application ID"
              isClearable
            />
          </div>
          <div
            style={{ border: "1px solid #017C57" }}
            className="text-[#017C57] px-6 py-2 rounded-full cursor-pointer"
            onClick={handleSave}
          >
            {type == "add" ? "Add" : "Update"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewRpaUser;
